const CURRENCY_COUNTRY_MAP = {
  USD: 'US',
  CA: 'CA',
};

export function getCountryByCurrencyCode(currencyCode) {
  const country = CURRENCY_COUNTRY_MAP[currencyCode] ?? 'US';
  return country;
}
